module.exports = __webpack_public_path__ + "static/media/children.2964e6bd.png";